import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import Section from '@segment/matcha/recipes/Section'

import Testimonial from '@segment/templates/Testimonial'

const TestimonialBox: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSection variant="noCopy">
      <Testimonial company="trustpilot" />
    </StyledSection>
  )
}

const StyledSection = styled(Section)`
  padding: 40px 0 80px;
  max-width: 1060px;
`

export default TestimonialBox
